module.exports = __webpack_public_path__ + "img/tsBanner_txt.ae7fb6cb.png";